import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/43b1a7a9dc913fdbd622cad5f4bf97fa.png"
              alt="Tri County Ninja"
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('home')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('programs')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Programs
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('schedule')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Schedule
            </button>
            <button
              onClick={() => scrollToSection('events')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Events
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#0A1628] hover:text-[#FF6B35] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button
            onClick={() => scrollToSection('contact')}
             className="bg-[#FF6B35] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Book Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#0A1628] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 bg-[#0A1628] z-40 transform transition-transform duration-300 lg:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ top: '80px' }}
      >
        <div className="flex flex-col items-center justify-center h-full space-y-8">
          <button
            onClick={() => scrollToSection('home')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('programs')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Programs
          </button>
          <button
            onClick={() => scrollToSection('pricing')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Pricing
          </button>
          <button
            onClick={() => scrollToSection('schedule')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Schedule
          </button>
          <button
            onClick={() => scrollToSection('events')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Events
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-white text-2xl font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
          >
            Contact
          </button>
          <button className="bg-[#FF6B35] text-white px-10 py-4 rounded-full font-semibold hover:bg-[#ff5722] transition-all duration-300 whitespace-nowrap cursor-pointer">
            Book Now
          </button>
        </div>
      </div>
    </>
  );
}